import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory";

export class Others {
  constructor(store, parent) {
    this.store = store;
    this.parent = parent;
    this.label = 'Tesztkörzet';
    this.district = 'Tesztkörzet';
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.model = null;
    this.originalPosition = new THREE.Vector3(-5, 4.5, -5);
    this.colleagueGroup = new THREE.Group();
    this.colleagueGroup.position.y = .3;
    this.group.add(this.colleagueGroup);
    this.colleagues = [];
    this.load();
  }

  async load() {
    this.model = this.store.assetManager.getModel("office");
    this.model.scale.setScalar(.3);
    this.model.userData.type = "otheroffice";
    this.model.userData.instance = this;
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.model.userData.baseObject = true;
    this.group.position.copy(this.originalPosition);
    this.model.position.set(0, 0, 0);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    const box = new THREE.Box3().setFromObject(this.model);
    const size = new THREE.Vector3();
    box.getSize(size);
    this.nameLabel = createLabel('Egyéb irodák', {fontSize: this.store.config.isSmall ? 72 : 72, position: new THREE.Vector3(0, size.y + 2, 0)});
    this.model.add(this.nameLabel);
    this.group.add(this.model);
    this.store.input.clickables.push(this.model);
    this.group.updateWorldMatrix(true, true);
    this.group.traverse(child => {child.renderOrder = 1000;});
    
  }


  update() {
      if (!this.model) {return;}
      const isSelected = this.store.level.levelName === "OTHEROFFICE";
      const targetPosition = isSelected ? new THREE.Vector3(2, 3, 12) : this.originalPosition;
      this.group.position.lerp(targetPosition, 0.08);
      this.group.updateWorldMatrix(true, true);
      this.colleagues.forEach((colleague) => {colleague.update();});
 }

  getWorldPosition() {return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {this.parent.remove(this.group);}

}